import React, { useState, useEffect } from 'react';
import {
    filter,
    find,
    forEach,
    includes,
    isEmpty,
    isNil,
    join,
    lowerCase,
    map,
    replace,
    split,
} from 'lodash';
import { getVideos } from '../../services/youtube/youtubeService';
import Clamp from 'react-multiline-clamp';

const BlogYouTube = ({ mainVideoId, secondaryVideoIds, youtubeapikey }) => {
    const [mainVideo, setMainVideo] = useState({ player: {} });
    const [secondaryVideos, setSecondaryVideos] = useState([]);

    const initialize = async () => {
        const maxWidth =
            window.innerWidth < 1024
                ? window.innerWidth
                : window.innerWidth / 2;
        if (!isNil(mainVideoId)) {
            const mainVideoResponse = await getVideos(
                mainVideoId,
                maxWidth,
                youtubeapikey
            );
            if (
                !isNil(mainVideoResponse) &&
                !isNil(mainVideoResponse.items) &&
                !isEmpty(mainVideoResponse.items)
            ) {
                setMainVideo(mainVideoResponse.items[0]);
            }
        }

        if (!isNil(secondaryVideoIds) && !isEmpty(secondaryVideoIds)) {
            const secondaryVideosResponse = await getVideos(
                join(secondaryVideoIds, '%2C'),
                maxWidth,
                youtubeapikey
            );
            if (
                !isNil(secondaryVideosResponse) &&
                !isNil(secondaryVideosResponse.items) &&
                !isEmpty(secondaryVideosResponse.items)
            ) {
                setSecondaryVideos(secondaryVideosResponse.items);
            }
        }
    };

    const handleVideoClick = (id) => {
        const video = find(secondaryVideos, (v) => v.id === id);
        if (!isNil(video)) {
            const newSecondaryVideos = filter(
                secondaryVideos,
                (v) => v.id !== id
            );
            newSecondaryVideos.push(mainVideo);
            setSecondaryVideos(newSecondaryVideos);
            video.player.embedHtml = replace(
                video.player.embedHtml,
                'https://www.youtube.com/embed/' + id,
                'https://www.youtube.com/embed/' + id + '?autoplay=1'
            );
            setMainVideo(video);
        }
    };

    const parseDuration = (duration) => {
        const result = { h: 0, m: 0, s: 0 };
        const delimiters = ['H', 'M', 'S'];
        if (isNil(duration) || isEmpty(duration)) return result;

        let d = split(duration, 'T')[1];
        if (isNil(d) || isEmpty(d)) return result;

        forEach(delimiters, (delimiter) => {
            if (includes(d, delimiter)) {
                result[lowerCase(delimiter)] = Number(split(d, delimiter)[0]);
                d = split(d, delimiter)[1];
            }
        });

        return result;
    };

    const formatDuration = (duration) =>
        `${duration.h === 0 ? '' : `${duration.h}:`}${
            duration.m < 10 ? `0${duration.m}` : duration.m
        }:${duration.s < 10 ? `0${duration.s}` : duration.s}`;

    useEffect(() => {
        initialize();
    }, [mainVideoId, secondaryVideoIds]);

    return (
        <div className='blog-posts-video'>
            <div
                className='blog-posts-video-main'
                dangerouslySetInnerHTML={{
                    __html: mainVideo.player.embedHtml,
                }}
            />
            <div className='blog-posts-video-container'>
                {map(secondaryVideos, (video, idx) => (
                    <div
                        className='blog-posts-video-secondary'
                        key={idx}
                        onClick={() => {
                            handleVideoClick(video.id);
                        }}>
                        <div className='blog-posts-video-secondary-image'>
                            {video.snippet.thumbnails.standard && (
                                <img
                                    src={video.snippet.thumbnails.standard.url}
                                    alt={video.snippet.title}
                                />
                            )}
                            <div className='blog-posts-video-secondary-duration'>
                                {formatDuration(
                                    parseDuration(video.contentDetails.duration)
                                )}
                            </div>
                        </div>
                        <div className='blog-posts-video-secondary-text'>
                            <h3>{video.snippet.title}</h3>
                            {window.innerWidth >= 1280 && (
                                <Clamp lines={window.innerWidth < 1600 ? 3 : 4}>
                                    <p>{video.snippet.description}</p>
                                </Clamp>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlogYouTube;
